module.exports = __webpack_public_path__ + "media/site/images/startups/jedziemyrazem-tablet-6f4621b2b43a06faf3b82cc10462d0d4.png";